import React, { Component } from 'react';
import apiClient from '../Utils/apiClient';
import MainCompanyController from '../Controllers/MainCompanyController';
import CompanySelect from '../Components/CompanySelect';
import { toastSuccess, toastError } from '../Utils/toast';
const _ = require('lodash');

export class AddCompany extends Component {
    constructor(props) {
        super(props);
        this.scopedMainCompanyId = localStorage.getItem('userRole') === 'Admin'
            ? (localStorage.getItem('mainCompanyId') || '')
            : '';
        this.state = {
            formValues: [{ firmaname: "", ownername: "", shortname: "", status: "", phone: "", production: "", loginmethod: "", main_company_id: this.scopedMainCompanyId }],
            company_fields : [],
            mainCompanies: [],
            messageError: "",
            messageSuccess: ""
        }
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    componentDidMount() {
        MainCompanyController.list()
            .then((mainCompanies) => this.setState({ mainCompanies: mainCompanies || [] }))
            .catch((err) => console.error('Failed to load main companies', err));
    }

    mainChange(i, e) {
        let formValues = this.state.formValues;
        formValues[i][e.target.name] = e.target.value;
        this.setState({ formValues });
    }

    handleCompanyValueChange(i, e) {
        let company_fields = this.state.company_fields;
        if (company_fields[i].id) {
            company_fields[i].value = e.target.value;

        } else {
            company_fields[i]['value'] = e.target.value;
        }
        this.setState({ company_fields });
    }
    handleCompanyNameChange(i, e) {
        let company_fields = this.state.company_fields;
        if (company_fields[i].id) {
            company_fields[i].name = e.target.value;

        } else {
            company_fields[i]['name'] = e.target.value;
        }
        this.setState({ company_fields });
    }

    addFormFields() {
        this.setState(({
            company_fields: [...this.state.company_fields, {}]
        }))
    }

    async removeFormFields(i, el) {
        if (!_.isEmpty(el[i])) {
            let res = await
                apiClient.delete('companies/fields/' + el[i].id)
                    .then(response => { console.log(response) })
                    .catch(error => {
                        console.error('Error fetching data:', error);
                    });
        }
        let company_fields = this.state.company_fields;
        company_fields.splice(i, 1);
        this.setState({ company_fields });
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        let mainvalue = this.state.formValues[0];

        let extvalue = this.state.company_fields;
        try {
            var postdata = {
                name_firma: mainvalue.firmaname,
                owner_name: mainvalue.ownername,
                phone: mainvalue.phone.replace(/ /g, ''),
                short_name: mainvalue.shortname,
                status: mainvalue.status,
                production: mainvalue.production,
                loginmethod: mainvalue.loginmethod,
                main_company_id: mainvalue.main_company_id || null,
                company_fields: extvalue,
            };
            console.log(postdata);

            let res = await apiClient.post('companies', postdata);
            let resJson = res.data;
            console.log(resJson);
            if (resJson.error === false) {
                if(resJson.data) {
                    var errorObj = []
                    resJson.data.forEach(element => {
                        errorObj[element.field] = (errorObj[element.field])? errorObj[element.field] + ', ' + element.message: element.message
                    });
                    this.setState({ messageError: errorObj});
                } else {
                    this.setState({ messageError: resJson.data});
                }
                toastError('Failed to create company');
            }
            if (resJson.success == true) {
                this.setState({ messageSuccess: "Company has been registered!!" });
                toastSuccess('Company created');
                this.setState({
                    formValues: [{ firmaname: "", ownername: "", shortname: "", status: "", phone: "", production: "", loginmethod: "", main_company_id: this.scopedMainCompanyId }],
                    extraValues: [{ name: "", value: "" }]
                })

            }
        } catch (err) {
            console.log(err);
            this.setState({ messageError: "Some error occured" });
            toastError(err.response?.data?.message || 'Some error occurred');

        }
    };

    render() {
        const { company_fields } = this.state;
        return (
            <div className="main-panel">
                <div className="content-wrapper">
                    <div className="card registration_form" >
                        <div className="modal-header">
                            <h3 className='card-heading'>New Company</h3>
                        </div>
                        <form onSubmit={this.handleSubmit} >
                            <div className="modal-body">
                                <div className="message">
                                    {
                                        this.state.messageSuccess ? <p className='alert alert-success'>{this.state.messageSuccess}</p>
                                        : (this.state.messageError && !Array.isArray(this.state.messageError) ) ? <p className='alert alert-warning'>{this.state.messageError}</p> 
                                                : null
                                    }
                                </div>
                                {this.state.formValues.map((ele, inx) => (
                                    <div className='row' key={inx} >
                                        <div className='col-lg-6'>
                                            <div className="form-group text-left">
                                                <label className="form-group-text">Firma Name</label>
                                                <input type="text" className="form-control" name="firmaname"
                                                    value={ele.firmaname}
                                                    onChange={e => this.mainChange(inx, e)} />
                                                    {this.state.messageError && <span className='text text-danger text-small'>{this.state.messageError['name_firma']}</span>}
                                            </div>
                                        </div>
                                        <div className='col-lg-6'>
                                            <div className="form-group text-left">
                                                <label className="form-group-text">Owner name</label>
                                                <input type="text" className="form-control" name="ownername"
                                                    value={ele.ownername}
                                                    onChange={e => this.mainChange(inx, e)} />
                                                {this.state.messageError && <span className='text text-danger text-small'>{this.state.messageError['owner_name']}</span>}
                                            </div>
                                        </div>
                                        <div className='col-lg-6'>
                                            <div className="form-group text-left">
                                                <label className="form-group-text">Phone</label>
                                                <input type="text" className="form-control" name="phone"
                                                    value={ele.phone}
                                                    onChange={e => this.mainChange(inx, e)} />
                                                {this.state.messageError && <span className='text text-danger text-small'>{this.state.messageError['phone']}</span>}
                                            </div>
                                        </div>
                                        <div className='col-lg-6'>
                                            <div className="form-group text-left">
                                                <label className="form-group-text">Short Name</label>
                                                <input type="text" className="form-control" name="shortname"
                                                    value={ele.shortname}
                                                    onChange={e => this.mainChange(inx, e)} />
                                                {this.state.messageError && <span className='text text-danger text-small'>{this.state.messageError['short_name']}</span>}
                                            </div>
                                        </div>

                                        <div className='col-lg-6'>
                                            <div className="form-group text-left">
                                                <label className="form-group-text">Status</label>
                                                <select className="form-select form-control" name="status"
                                                    onChange={e => this.mainChange(inx, e)}
                                                    value={ele.status}>
                                                    <option value="true">Active</option>
                                                    <option value="false">In Active</option>
                                                </select>
                                                {this.state.messageError && <span className='text text-danger text-small'>{this.state.messageError['status']}</span>}
                                            </div>
                                        </div>
                                        <div className='col-lg-6'>
                                            <div className="form-group text-left">
                                                <label className="form-group-text">Production Mode</label>
                                                <select className="form-select form-control" name="production"
                                                    onChange={e => this.mainChange(inx, e)}
                                                    value={ele.production}>
                                                    <option value="live">Live</option>
                                                    <option value="test">Test</option>
                                                </select>
                                                {this.state.messageError && <span className='text text-danger text-small'>{this.state.messageError['production']}</span>}
                                            </div>
                                        </div>
                                        <div className='col-lg-6'>
                                            <div className="form-group text-left">
                                                <label className="form-group-text">Api key / Client ID</label>
                                                <p className="text-muted" style={{ marginBottom: 0 }}>Auto-generated when the company is created.</p>
                                            </div>
                                        </div>
                                        <div className='col-lg-6'>
                                            <div className="form-group text-left">
                                                <label className="form-group-text">Login method</label>
                                                <select className="form-select form-control" name="loginmethod"
                                                    onChange={e => this.mainChange(inx, e)}
                                                    value={ele.loginmethod}>
                                                    <option value="">Select option ..</option>
                                                    <option value="code">Email(pincode)</option>
                                                    <option value="url">Email(Url)</option>
                                                    <option value="sms">SMS</option>
                                                </select>
                                                {this.state.messageError && <span className='text text-danger text-small'>{this.state.messageError['loginmethod']}</span>}
                                            </div>
                                        </div>
                                        <div className='col-lg-6'>
                                            <div className="form-group text-left">
                                                <label className="form-group-text">Main Company</label>
                                                <CompanySelect
                                                    companies={this.state.mainCompanies}
                                                    value={ele.main_company_id}
                                                    onChange={(id) => this.mainChange(inx, { target: { name: 'main_company_id', value: id } })}
                                                    placeholder="— None —"
                                                    disabled={!!this.scopedMainCompanyId}
                                                    variant="field"
                                                />
                                                {this.scopedMainCompanyId && <p className="text-muted" style={{ marginBottom: 0 }}>Locked to your assigned main company.</p>}
                                                {this.state.messageError && <span className='text text-danger text-small'>{this.state.messageError['main_company_id']}</span>}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <h4 className='text-left'>Extra fields</h4>
                                {company_fields.map((item, index) => (
                                        <div className='row form-group' key={index}>
                                            <div className={index ? 'col-lg-5' : 'col-lg-6'}>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name='name'
                                                    value={(item.name) ?? ''}
                                                    onChange={(e) => this.handleCompanyNameChange(index, e)}
                                                />
                                            </div>
                                            <div className='col-lg-6'>
                                                {
                                                    (item.type == 'textarea') ?
                                                        <textarea type={(item.type) ? item.type : "text"}
                                                            className="form-control"
                                                            name='value'
                                                            value={item.value ?? ''}
                                                            onChange={(e) => this.handleCompanyValueChange(index, e)}
                                                        ></textarea>
                                                        :
                                                        <input
                                                            type={(item.type) ? item.type : "text"}
                                                            className="form-control"
                                                            name='value'
                                                            value={item.value}
                                                            onChange={(e) => this.handleCompanyValueChange(index, e)}
                                                        />
                                                }
                                            </div>
                                            {
                                                index ?
                                                    <div className='col-lg-1'>
                                                        <button type="button" className="btn btn-icon btn-rounded btn-warning remove float-right remove" onClick={() => this.removeFormFields(index, company_fields)}><i className='bi bi-trash-fill'></i></button>
                                                    </div>
                                                    : <div className='col-lg-1'></div>
                                            }
                                        </div>
                                    ))
                                    }
                                <div className="button-section">
                                    <button className="btn btn-primary btn-icon btn-rounded float-right" type="button" onClick={() => this.addFormFields()}><i className='bi bi-plus'></i></button>
                                </div>
                                <div className='clearfix'></div>
                            </div>

                            <div className="modal-footer">
                                <button className="btn btn-primary float-left" type="submit">Create</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}
